<!-- static content data from lang: past_script_details -->
<template>
    <div class="container h-100">
        <div class="py-3 h-100" v-loading="loading">
            <template v-if="errored">
                <NotFound/>
            </template>
            <template v-else-if="data">
                <b-card class="script-details">
                    <template slot="header">
                        <div class="text-center">
                            <h5 class="id">{{lang.label.header}}</h5>
                        </div>
                    </template>
                    <div class="full-detail">
                        <div class="row justify-content-end d-flex" v-if="data.patientId==''"> 
                            
                        </div>
                        <div class="row justify-content-end d-flex" v-else> 
                           <a  href="#"  class="col-md-3" @click="pastScript(data)" >{{lang.label.buttons.pastScript}}</a>
                        </div>
                        
                        <div class="row">
                            <div class="col-md-12">
                                <b-card class="card-box" body-class="p-0">
                                    <div class="row">
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.patientName}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.patientName!=''? data.patientName :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.dob}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.dob!=''? data.dob :lang.label.nodata)}}</span>
                                        </div>
                                        

                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.idNumber}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.idNumber!=''? data.idNumber :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.email}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.email!=''? data.email :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.phoneNumber}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.mobile!=''? data.mobile :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-12">
                                            <hr/>
                                        </div>
                                        <div class="col-12" v-if="data.formName != ''">
                                            <div class="d-flex flex-wrap align-items-center justify-content-between my-2">
                                                <h5 class="font-weight-bold my-1 mr-3">{{data.formName}}</h5>
                                                <!-- GLP-1 follow-ups: the patient's application and earlier follow-ups -->
                                                <b-btn v-if="data.isFollowup" variant="primary" class="my-1" @click="glp1History(data)">
                                                    <i class="fas fa-chart-line mr-2"></i>{{lang.label.buttons.glp1History}}
                                                </b-btn>
                                            </div>
                                        </div>
                                    

                                        <div class="col-12" v-for="fdata in data.formDetails">
                                            <div class="row">
                                                <div class="col-6">
                                                <span class="my-2 d-block">
                                                    {{ fdata.key }}
                                                </span>
                                            </div>
                                            <div class="col-6">
                                                <!-- Signatures come as image links (type: image) -->
                                                <a v-if="fdata.type === 'image'" :href="fdata.value" target="_blank" rel="noopener" class="my-2 d-block">
                                                    <img :src="fdata.value" :alt="fdata.key" class="form-detail-image">
                                                </a>
                                                <span v-else class="my-2 d-block" :class="{ 'form-detail-yes': isYesAnswer(fdata) }">
                                                    {{ fdata.value }}
                                                </span>
                                            </div>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="row">
                                                 <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.medicineRequired}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.medication!=''? data.medication :lang.label.nodata)}}</span>
                                        </div>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <hr/>
                                        </div>


                                          <div class="col-12">
                                            <div class="row">
                                                <div class="col-6">
                                                    <span class="my-2 d-block">{{lang.label.nursingPractitioner}}:</span>
                                                </div>
                                                <div class="col-6">
                                                    <span class="my-2 d-block">{{(data.nursingPractitioner!=''? data.nursingPractitioner :lang.label.nodata)}}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-6">
                                                    <span class="my-2 d-block">{{lang.label.clinicEmail}}:</span>
                                                </div>
                                                <div class="col-6">
                                                    <span class="my-2 d-block">{{(data.pharmacyEmail!=''? data.pharmacyEmail :lang.label.nodata)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-6">
                                                    <span class="my-2 d-block">{{lang.label.clinicName}}:</span>
                                                </div>
                                                <div class="col-6">
                                                    <span class="my-2 d-block">{{(data.pharmacyName!=''? data.pharmacyName :lang.label.nodata)}}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12">
                                            <hr/>
                                        </div>

                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-6">
                                                    <span class="my-2 d-block">{{lang.label.allergicTo}}:</span>
                                                </div>
                                                <div class="col-6">
                                                    <span class="my-2 d-block">{{(data.allergies.length ? data.allergies.join(', ') :lang.label.nodata)}}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12">
                                            <hr/>
                                        </div>
                    
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.patientImages}}:</span>
                                        </div>
                                        <div class="col-6">
                                        <carousel autoplay loop v-if="data.formImages.length">
                                            <slide v-for="(image,index) in data.formImages" v-bind:key="index">
                                                <img :src="image" height="300" width="300" alt="img">
                                            </slide>
                                        </carousel>
                                        <span v-else>{{ lang.label.nodata }}</span>
                                        </div>

                                        <div class="col-12">
                                            <hr/>
                                        </div>

                                        <div class="col-12">
                                            <div class="row">
                                                      <div class="col-6">
                                                            <span class="my-2 d-block">{{lang.label.notes}}:</span>
                                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{(data.notes!=''? data.notes :lang.label.nodata)}}</span>
                                        </div>
                                    </div>
                            </div>
                                        
                                        
<!--                                         
                                       
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.bloodPressure}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.bloodPressure!=''? data.bloodPressure :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.height}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.height!=''? data.height :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.weight}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.weight!=''? data.weight :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.bmi}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.bmi!=''? data.bmi :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.pulse}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.pulse!=''? data.pulse :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.glucose}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.glucose!=''? data.glucose :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.smoker}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.smoker!=''? data.smoker :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.riskFactors}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.riskFactors!=''? data.riskFactors :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.nursingPractitioner}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.nursingPractitioner!=''? data.nursingPractitioner :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.clinicEmail}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.clinicEmail!=''? data.clinicEmail :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.notes}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.notes!=''? data.notes :lang.label.nodata)}}</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{lang.label.nurseNote}}:</span>
                                        </div>
                                        <div class="col-6">
                                            <span class="my-2 d-block">{{ (data.nurseNote!=''? data.nurseNote :lang.label.nodata)}}</span>
                                        </div> -->



                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group class="mb-0 btn-mt">
                                                <b-btn
                                                    type="submit"
                                                    variant="secondary"
                                                    class="w-100 mb-3"
                                                    @click="cardClicked(data)"
                                                >{{lang.label.buttons.createScriptModal}}
                                                </b-btn>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group class="mb-0 btn-mt">
                                                <b-btn
                                                    type="submit"
                                                    variant="primary"
                                                    class="w-100"
                                                    @click="rejectRequest"
                                                >{{lang.label.buttons.reject}}
                                                </b-btn>
                                            </b-form-group>
                                        </div>
                                    </div>
                                </b-card>
                            </div>
                        </div>
                    </div>
                </b-card>
            </template>
        </div>
        <b-modal
            id="modal-center"
            ref="reject_request"
            centered
            :title="lang.label.rejectRequest"
            hide-footer
        >
            <ValidationObserver ref="observer" v-slot="{ passes }">
                <b-form @submit.stop.prevent="passes(onSubmit)">
                        <b-form-group>
                            <div class="row">
                            <div class="col-12 col-md-12">
                                <label class="label-control" for="name">
                                    {{lang.label.reason}}:
                                    <span class="text-danger">*</span>
                                </label>
                            </div>
                            <div class="col-12 col-md-12">
                                <ValidationProvider
                                    name="reason"
                                    rules="required"
                                    v-slot="validationContext"
                                >
                                    <b-form-textarea
                                        :state="getValidationState(validationContext)"
                                        v-model="reason"
                                        ref="prescription"
                                        type="text"
                                        :placeholder="lang.label.enterReason"
                                        rows="3"
                                        max-rows="3"
                                    ></b-form-textarea>
                                    <b-form-invalid-feedback style="color: red;font-size: 12px;" v-if="validationContext.failedRules.required"> {{lang.label.reasonRequired}}</b-form-invalid-feedback>
                                    <!--<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                                </ValidationProvider>
                            </div>
                            </div>
                        </b-form-group>
                        <div class="mt-3">
                            <b-btn type="submit" :disabled="onSend" variant="primary" class="w-100">{{lang.label.buttons.submit}}</b-btn>
                        </div>
                </b-form>
            </ValidationObserver>
        </b-modal>
        <b-modal id="modal-center" ref="create_script" centered hide-footer>
            <div class="share-buttons">
                <b-btn variant="primary" class="w-100"><a style="color:#FFF" target="_blank" @click="createScript(1)">{{lang.label.buttons.createScript}}</a></b-btn>
                <b-btn variant="primary" class="w-100 btn-copy" @click="createScript(2)">{{lang.label.buttons.createEScript}}</b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
	import Vue from "vue";
	import jsondata from "../assets/json/data.json";
	import VueSilentbox from "vue-silentbox";

	Vue.use(VueSilentbox);
	import VueClipboard from 'vue-clipboard2';
	import {mapGetters} from "vuex";

	Vue.use(VueClipboard);
	var moment = require('moment'); // require
	import NotFound from "../components/NotFound.vue";

	export default {

		components: {
			NotFound
		},
		data() {
			return {
				data: {},
				mailDetails: '',
				shareUrl: '',
				reason: '',
				id: this.$route.params.id,
				lang: this.$lang.group_request_details,
				images: [],
				pdf: [],
				loading: true,
				errored: false,
				models: {
					idNumber: "",
					patientMinor: [],
					parentName: "",
					parentIDNumber: "",
					medicineRequired: "",
					specialInstructions: "",
				},
				onSend:false
			}
		},
		computed: {
			...mapGetters({
				login: "login",
				groupRequestDetails: "groupRequestDetails",
			})
		},
		mounted() {
			this.data = this.groupRequestDetails;
            // console.log("dataHere",this.data);
            this.loading = false;

		},
		methods: {
			// API flags answers to highlight with isAnswer: "yes"
			isYesAnswer(fdata) {
				return String(fdata.isAnswer).toLowerCase() === 'yes';
			},
			formatAddress(address) {
				return address.replace(/\n/g, '<br/>');
			},
			scriptDetail() {
//                return 'Dear '+this.data.patientsName+', you submitted a request for a script / form to '+this.login.name+'. If you requested the document, please click this link '+'"' +this.data.shared_url +'"'+' to make payment and download the document. Thank you, '+this.login.name;
			},
			scriptDetails() {
				let subject = 'mailto:' + this.data.pEmail + '?subject=Payscript – Script / Form from ' + this.login.practiceName + ' &body=';
				let body = 'Dear ' + this.data.patientsName + ',' + '%0D%0A%0D%0A' + 'You submitted a request for a script / form to ' + this.login.practiceName + '. If you requested the document, please ' + 'OPEN ' + this.data.shared_url + ' to pay and access the document.' + '%0D%0A%0D%0A' + 'Thank you, %0D%0A' + this.login.practiceName;
				return subject + body;
			},
			formatDob(date) {
				return moment(date).format('DD/MM/YYYY');
			},
			formatScriptDate(date) {
				let format = moment(date).format('Do MMM YYYY');
				moment.locale('en', {
					ordinal: num => {
						const b = num % 10;
						const output = (~~(num % 100 / 10) === 1) ? 'th' :
							(b === 1) ? 'st' :
								(b === 2) ? 'nd' :
									(b === 3) ? 'rd' : 'th';
						return num + '<sup>' + output + '</sup>';
					},
				});

				return moment(date).format('Do MMM YYYY');
			},
			onCopy: function (e) {

				if (this.data.shared_url != "") {
					return this.notifyVue('success');
				} else {
					return this.notifyVueError('error');
				}
			},
			onError: function (e) {
				this.notifyVueError('error');
			},
			notifyVue(type = 'success') {

				this.$notify({

					message: this.lang.label.copiedlink,
					timeout: 5000,
					type
				});
			},
			notifyVueError(type = 'error') {

				this.$notify({

					message: this.lang.label.errorIncopyLink,
					timeout: 5000,

					type
				});
			},
			formatAddress(address) {
				if (address) {
					return address.replace(/\n/g, '<br/>');
				}
			},
			formatPrescription(prescription) {
				if (prescription) {
					return prescription.replace(/\n/g, '<br/>');
				}

			},
			Download(url) {
				url = this.pdf;
				document.getElementById('my_iframe').src = url;
			},
			rejectRequest() {
                this.$refs.reject_request.show();
			},
			onSubmit() {
				let self = this;
				self.onSend=true;
                self.loading=true;
                // old one's
				// let params = {
				// 	"reason": this.reason,
				// 	"groupRequestId": this.data.groupRequestId
				// };
				// this.$store.dispatch('rejectGroupRequest', params).then(value => {
				// 	// console.log('value',value);
				// 	if (value.message) {
				// 		self.open(value.message);
				// 		this.$refs.reject_request.hide();
				// 		self.onSend=false;
				// 	}
				// })

                let params = {
					"reason": this.reason,
					"formsManagementId": self.data.formsManagementId
				};
                	self.$store.dispatch('rejectGroupRequest', params).then(value => {
					// console.log('value',value);
					if (value.message) {
                        self.loading=false;
                        setTimeout(()=>{
                          self.open(value.message);
                          self.$refs.reject_request.hide();
                          self.onSend=false;
                        },50)
					}
				})
			},
			open(message) {
				let self = this;
				this.$alert(message, '', {
					confirmButtonText: 'OK',
					callback: action => {
					    self.loading = false;
						// self.$router.push({name:'group-request-list'})
                        //  console.log(this.login.token);
						// self.$router.push({name:'past-request-list'});
						self.$router.push({name:'home'});
					}
				});
			},
			getValidationState( { dirty, validated, valid = null }) {
					return dirty || validated ? valid : null;
			},
			cardClicked(patient){
				this.patientInfo = patient;
				this.$refs.create_script.show();
				// this.$bvModal.show('modal-center');
			},
			createScript(type){
				this.patientInfo.name = this.patientInfo.patientName;
				this.$store.commit('setPatientInfo',this.patientInfo);
				this.$store.commit('setFromGroupRequests', true);
				if(type == 1){
					this.$router.push({name: 'create-script'});
				}else{
					this.$router.push({name: 'create-electronic-script'});
				}
			},
            glp1History(request) {
                this.$router.push({name: 'glp1-history', params: {formsManagementId: request.formsManagementId}});
            },
            pastScript(patient){
                this.$store.commit('setPatientInfo',patient);
                this.$store.commit('setFromGroupRequests', true);
                this.$router.push({name: 'past-script',params: {flag: false}});
            }

		}
	};
</script>
